<ng-container>
  <app-management-element-header></app-management-element-header>
  <router-outlet></router-outlet>
</ng-container>

